'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './news-archive.routes';

require('moment');

export class NewsArchiveComponent {
  constructor(NewsService, Auth, $state, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.currentPage = 1;
    this.itemsPerPage = Config.getPagination("newsArchive");

    this.isAdmin = Auth.isAdminSync;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, 'News Archive');

    const currentYear = moment().year();

    this.quarterYears = [currentYear, currentYear - 1, currentYear - 2];     // Q1–Q4
    this.fullYears = [currentYear - 3, currentYear - 4, currentYear - 5];    // Whole-year buckets

    this.newsByRange = {};

    // Create dynamic buckets
    this.quarterYears.forEach(year => {
      for (let q = 1; q <= 4; q++) {
        this.newsByRange[`Q${q}-${year}`] = [];
      }
    });

    this.fullYears.forEach(year => {
      this.newsByRange[`${year}`] = [];
    });

    this.newsByRange["older"] = [];

    this.news = [];

    // Load news data
    NewsService.query(data => {
      data.forEach(news => {
        if (!news.validUntil) return;

        const d = moment(news.meta.creationDate);
        const year = d.year();

        // 1. Quarter years (current, -1, -2)
        if (this.quarterYears.includes(year)) {
          const q = Math.floor(d.month() / 3) + 1; // month() is 0–11
          this.newsByRange[`Q${q}-${year}`].push(news);
          return;
        }

        // 2. Full-year buckets (current -3, -4, -5)
        if (this.fullYears.includes(year)) {
          this.newsByRange[`${year}`].push(news);
          return;
        }

        // 3. Older
        if (year < this.fullYears[this.fullYears.length - 1]) {
          this.newsByRange["older"].push(news);
        }
      });
    });

  }

  switchNewsByRange(range) {
    this.news = this.newsByRange[range];
  }

  countNewsByRange(range) {
    if (!this.newsByRange[range] || !Array.isArray(this.newsByRange[range]))
      return 0;

    return this.newsByRange[range].length || 0;
  }
}

export default angular.module('conduuApp.newsArchive', [uiRouter])
  .config(routes)
  .component('newsArchive', {
    template: require('./news-archive.html'),
    controller: NewsArchiveComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/news/archive/news-archive.component.js